<template>
  <div class="animated fadeIn uni-faculty">
    <vLoading v-if="vLoading" />
    <div v-if="$router.currentRoute.path == '/accelerator/registeredMasters'">
      <v-card class="common-card card-height">
        <v-row>
          <v-col class="pb-0">
            <h4 class="fs-xxlarge c-dark pt-2">پایان‌نامه‌های ثبت شده</h4>
          </v-col>
          <v-col md="7" sm="8" class="pb-0">
            <div class="d-flex flex-row float-end">
              <v-text-field
                v-if="deviceType == 'desktop'"
                rounded
                filled
                class="search-box mt-2 mt-sm-0"
                placeholder="جستجو..."
                v-model="filter"
              >
                <template v-slot:prepend-inner>
                  <v-icon class="ps-3">$searchIcon</v-icon>
                </template>
              </v-text-field>
            </div>
          </v-col>
        </v-row>
        <v-row v-if="deviceType == 'mobile'">
          <v-col>
            <v-text-field
              rounded
              filled
              class="search-box mt-2 mt-sm-0"
              placeholder="جستجو دراعضا..."
              v-model="filter"
            >
              <template v-slot:prepend-inner>
                <v-icon class="ps-3">$searchIcon</v-icon>
              </template>
            </v-text-field>
          </v-col>
        </v-row>

        <div class="mt-6">
          <b-table
            responsive
            small
            show-empty
            stacked="sm"
            tbody-tr-class="trClass"
            thead-class="thClass"
            empty-filtered-text="نتیجه‌ای یافت نشد"
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :busy="tableBusy"
            @filtered="onFiltered"
            :filter-function="myFilterFn"
            empty-text="درخواست پایان‌نامه‌ای برای نمایش وجود ندارد"
            class="table table-secondary"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value ? data.value : "--" }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.index + 1 + perPage * (currentPage - 1) }}
              </div>
            </template>
            <template v-slot:cell(operation)="data">
              <div
                style="text-align: center; vertical-align: middle"
                class="d-flex flex-row justify-content-center"
              >
                <v-btn
                  @click="goToRequest(data.item.id)"
                  class="btn-border bc-purple c-purple"
                  elevation="0"
                >
                  <v-icon class="white--text pe-1">mdi-eye-outline</v-icon>
                  <span class="white--text">مشاهده</span>
                </v-btn>
                <!--<div
                  @click="openDialog(data.item, 'delete')"
                  class="trash-icon pointer ps-3 pe-0"
                >
                  <v-icon>$Trash</v-icon>
                </div>-->
              </div>
            </template>
            <div slot="table-busy" class="text-center text-danger my-2">
              <strong class="text-primary">در حال بارگذاری...</strong>
              <br />
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-table>
          <v-row v-if="totalRows" class="mt-4">
            <v-col>
              <v-pagination
                v-model="currentPage"
                :length="Math.ceil(totalRows / perPage)"
                :total-visible="5"
                prev-icon="arrow_back"
                next-icon="arrow_forward"
                class="float-end"
              ></v-pagination>
            </v-col>
          </v-row>
        </div>
      </v-card>
      <v-file-input
        @change="myUpload(file)"
        v-model="file"
        ref="upload"
        outlined
        dense
        v-show="false"
      ></v-file-input>
    </div>
  </div>
</template>

<script>
function checkCodeMeli(code) {
  //NOTE employee's checking validation of national code
  var L = code.length;

  if (L < 8 || parseInt(code, 10) == 0) return false;
  code = ("0000" + code).substr(L + 4 - 10);
  if (parseInt(code.substr(3, 6), 10) == 0) return false;
  var c = parseInt(code.substr(9, 1), 10);
  var s = 0;
  for (var i = 0; i < 9; i++) s += parseInt(code.substr(i, 1), 10) * (10 - i);
  s = s % 11;
  return (s < 2 && c == s) || (s >= 2 && c == 11 - s);
  return true;
}
export default {
  data() {
    return {
      uploadedFiles: [],
      uploadPercentage: 0,
      isUploaded: false,
      file: [],
      myFile: new Object({
        uploadPercentage: 0,
      }),
      image: [],
      filter: "",
      selected: {},
      showImage: false,
      vLoading: false,
      editMemberDialog: false,
      deleteMemberDialog: false,
      addImageDialog: false,
      addMemberDialog: false,
      selectedMember: {},
      newMember: {},
      deviceType: "",
      uploading: false,
      items: [],
      currentPage: 1,
      totalRows: "",
      perPage: 10,
      tableBusy: false,
      filter: "",
      fields: [
        { key: "index", label: "#" },
        { key: "faSubject", label: "عنوان فارسی" },
        { key: "researcherName", label: "نام پژوهشگر" },
        { key: "requestsCode", label: "کد طرح" },
        { key: "registerDate", label: "تاریخ ثبت" },
        { key: "status", label: "وضعیت" },
        { key: "university", label: "دانشگاه" },
        // { key: "version", label: "نسخه" },
        { key: "lastUpdate", label: "آخرین بروزرسانی" },
        { key: "operation", label: "عملیات" },
      ],
    };
  },
  methods: {
    getRequests() {
      this.tableBusy = true;
      this.$http
        .post(
          this.baseUrl + "/setad/accelerator/requests/master/getAll",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.items = res.data;
          this.totalRows = this.items.length;
          this.tableBusy = false;
        })
        .catch((err) => {
          this.tableBusy = false;
          if (err.response.status == 403)
            // this.$router.replace("/unauthorize");
            this.$router.push({
              path: "/login",
              query: { return: window.location.pathname },
            });
        });
    },
    goToRequest(id) {
      let link = "/accelerator/masterProposal/" + id;
      window.open(link, "_blank");
    },
    myUpload(file) {
      if (!file) {
        return;
      }
      //CHECK FILE SIZE
      let sizeMB = file.size / 1024 / 1024;

      if (sizeMB > 5) {
        this.toast(
          "حجم فایل " + file.name + " نباید از 5 مگابایت بیشتر باشد",
          "error"
        );
        return;
      } else if (file.type != "image/jpeg" && file.type != "image/png") {
        this.toast("فرمت فایل مورد نظر مجاز نمی‌باشد.", "error");
        return;
      } else {
        this.uploading = true;

        // START UPLOAD PROCESS
        this.myFile.showProgress = true;
        this.myFile.variant = "info";
        this.myFile.uploadPercentage = 0;
        this.myFile.isUploaded = false;
        this.myFile.uploadButDisable = true;
        var formData = new FormData();
        formData.append(file.name, file);

        this.$http
          .post(this.baseUrl + "/setad/university/profile/upload", formData, {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
            onUploadProgress: ((progressEvent) => {
              this.myFile.uploadPercentage =
                Math.round((progressEvent.loaded * 100) / progressEvent.total) -
                1;
            }).bind(this),
          })
          .then((res) => {
            if (res.status == 200) {
              this.myFile.isUploaded = true;
              this.myFile.uploadPercentage = 100;
              this.myFile.striped = false;
              this.myFile.variant = "success";
              this.myFile.uploadButDisable = false;
              this.uploadedFiles = res.data;
              this.addImageDialog = false;
              if (this.selectedMember) {
                this.selectedMember.avatar = this.uploadedFiles.url;
              }
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.uploadedFiles = {};
            this.additionalFiles.contract = {};
            this.myFile.uploadPercentage = 0;
          });
      }
    },
    dragover(event) {
      event.preventDefault();
      // Add some visual fluff to show the user can drop its files
      // if (!event.currentTarget.classList.contains("bg-green-300")) {
      //   event.currentTarget.classList.remove("bg-gray-100");
      //   event.currentTarget.classList.add("bg-green-300");
      // }
    },
    dragleave(event) {
      // Clean up
      // event.currentTarget.classList.add("bg-gray-100");
      // event.currentTarget.classList.remove("bg-green-300");
    },
    drop(event) {
      event.preventDefault();
      this.file = event.dataTransfer.files;
      if (Array.from(this.file).length) {
        if (Array.from(this.file).length > 1) {
          this.toast(
            " در این بخش شما مجاز به آپلود بیش از یک عکس نمی‌باشید.",
            "error"
          );
          return;
        }
        Array.from(this.file).forEach((file) => {
          this.myUpload(file);
        });
      }
      // Clean up
      // event.currentTarget.classList.add("bg-gray-100");
      // event.currentTarget.classList.remove("bg-green-300");
    },
    validateEmail(email) {
      //NOTE checking validation of email
      if (email) {
        var re =
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase()) ? true : false;
      } else return true;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    myFilterFn(item, filter) {
      if (
        item.faSubject.includes(filter) ||
        item.requestsCode.includes(filter) ||
        item.registerDate.includes(filter) ||
        item.university.includes(filter) ||
        item.researcherName.includes(filter) ||
        item.status.includes(filter) ||
        item.lastUpdate.includes(filter)
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    if (window.screen.width < 850) {
      this.deviceType = "mobile";
    } else {
      if (document.body.clientWidth < 850) {
        this.deviceType = "mobile";
      } else {
        this.deviceType = "desktop";
      }
    }
    if (
      !document.body.classList.contains("sidebar-minimized") &&
      !document.body.classList.contains("brand-minimized")
    ) {
      document.body.classList.add("sidebar-minimized");
      document.body.classList.add("brand-minimized");
      this.toast(
        "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
      );
    }
    this.getRequests();
  },
};
</script>
<style lang="scss">
.modal-card {
  border-radius: 10px !important;
  img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
  .textField-box {
    .v-text-field .v-input__slot,
    .v-text-field fieldset {
      border-radius: 6px !important;
      border-color: #93329e !important;
    }
    .v-input__slot {
      margin-bottom: 25px;
      input {
        color: #656a81 !important;
      }
      .v-text-field__suffix {
        color: #656a81 !important;
      }
    }
  }
  .v-label {
    font-size: 0.9rem !important;
    color: #93329e !important;
    background-color: #fff;
    padding: 1px 10px;
    margin-bottom: 0 !important;
    height: 25px;
    transform: translateY(-31px);
  }
  .imageBox {
    position: relative;
    width: fit-content;
    margin: 0 auto;
    img {
      width: 100px;
      height: 100px;
      border-radius: 50%;
    }
    .edit-image {
      position: absolute;
      bottom: 3px;
      right: 0px;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      svg {
        transform: translate(2px, 13px) !important;
      }
      path {
        stroke: #fff;
      }
    }
  }
}
</style>
